var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6224 0.659319C18.3623 0.473514 17.9907 0.436352 17.6934 0.622158L0.450645 10.4327C0.153356 10.5813 -0.0324493 10.9158 0.00471176 11.2502C0.00471176 11.5847 0.227678 11.882 0.524967 12.0306L6.24778 14.4089V18.6081C6.24778 18.9426 6.39642 19.2399 6.69371 19.4257C6.84235 19.4628 6.991 19.5 7.10248 19.5C7.25113 19.5 7.43693 19.4628 7.58558 19.3885L11.7105 16.7129L15.3522 18.2737C15.4637 18.3108 15.5752 18.348 15.7239 18.348C15.8725 18.348 16.0211 18.2737 16.1326 18.1994C16.3928 18.0879 16.5414 17.8277 16.5786 17.5676L18.9569 1.51402C19.0684 1.17957 18.9197 0.845125 18.6224 0.659319ZM13.7172 4.93285L6.76803 12.6995L2.90328 11.0644L13.7172 4.93285ZM7.99435 16.973V15.1522L9.70376 15.8954L7.99435 16.973ZM15.0178 16.1555L8.47744 13.4056L16.8015 4.15246L15.0178 16.1555Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.ec397a4ae92a4c6b6d2c515e217b3223.svg";
export { ForwardRef as ReactComponent };